import { Page } from '@sainsburys-tech/luna-site-layout'
import { PageBody } from '@sainsburys-tech/luna-site-layout'
import { Container } from '@sainsburys-tech/luna-grid'
import styles from './styles.module.css'

export default function Pages({children}) {

    return(
        <Page className={styles.page}>
            <PageBody >
                <Container>
                    {children}
                </Container>
            </PageBody>
        </Page>
    )

}